import React, { useState } from "react";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarIngresoRequisa } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------

const CancelarRequisaMaterial = ({
  cerrar,
  actualizarIngresosScreen,
  selectedDetalle,
  toast,
  setSelected
}) => {
  const [loading, setLoading] = useState(false);

  const cancelarDetalle = async () => {

    const todosValidos = selectedDetalle.every((detalle) => detalle.IdEstado === 28);

    if(todosValidos){
      const eliminados = await EliminarIngresoRequisa(selectedDetalle);
  
      if (eliminados[0]?.ESTADO !== -1) {
        setLoading(true);
        toastShow(toast, "success", "Eliminado", eliminados[0].MENSAJE);
        actualizarIngresosScreen();
        setSelected([]);
        setTimeout(() => {
          cerrar();
          setLoading(false);
        }, 1000);
      } else {
        toastShow(toast, "error", "Error al eliminar", eliminados[0].MENSAJE);
      }
    }else{
      toastShow(toast, "error", "Error al eliminar", 'Algunas Requisas ya tienen salidas');
    }
  };

  return (
    <div id="Dialog" style={{width:'40vh'}}>
      <Toast ref={toast}/>
      <Loader loading={loading} querySelector={"#Dialog"} />
      <div className="flex">
        <div className="flex gap-3">
          <h5 className="m-0">¿Está seguro que desea eliminar la requisa?</h5>
          <p className="mt-1">Al eliminar la requisa, se eliminaran los detalles ingresados que pertenecen a esta requisa.</p>
        </div>
      </div>

        <div className="mt-3 d-flex justify-content-end">
          <Button
            icon="pi pi-times"
            label="Cancelar"
            className="p-button-text"
            onClick={() => cerrar(false)}
          />
          <Button
            icon="pi pi-check"
            label="Eliminar"
            className="p-button-text"
            onClick={() => {
              cancelarDetalle();
            }}
          />
        </div>

    </div>
  );
};

export default CancelarRequisaMaterial;
